import type { ReactNode } from "react";
import { Sidebar, type AppPage } from "./Sidebar";
import { TopBar, type PdfScreen } from "./TopBar";

interface Props {
  breadcrumb: string[];
  onLogout: () => void;
  userIniciais: string;
  userNome: string;
  pdfScreen?: PdfScreen;
  /** Task #196: refresh in-place da view atual (forwarded pra TopBar). */
  onRefresh?: () => void | Promise<void>;
  /** Task #88: forwarding pra TopBar — oculta botao Atualizar na Curva
   * de Mercado (F5 ja resolve refresh manual). */
  hideRefresh?: boolean;
  /** Task #88: forwarding pra TopBar — oculta botao Relatorio PDF na
   * Curva de Mercado (era placeholder desabilitado). */
  hidePdf?: boolean;
  activePage: AppPage;
  onNavigate: (p: AppPage) => void;
  children: ReactNode;
}

export function AppShell({
  breadcrumb,
  onLogout,
  userIniciais,
  userNome,
  pdfScreen,
  onRefresh,
  hideRefresh,
  hidePdf,
  activePage,
  onNavigate,
  children,
}: Props) {
  return (
    <div className="min-h-screen flex bg-indra-azul text-white">
      <Sidebar
        onLogout={onLogout}
        userIniciais={userIniciais}
        userNome={userNome}
        activePage={activePage}
        onNavigate={onNavigate}
      />
      <main className="flex-1 min-w-0 overflow-x-hidden p-8">
        <TopBar
          breadcrumb={breadcrumb}
          pdfScreen={pdfScreen}
          onRefresh={onRefresh}
          hideRefresh={hideRefresh}
          hidePdf={hidePdf}
        />
        {children}
      </main>
    </div>
  );
}
